function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_16",
  "data-name": "Rectangle 16",
  width: 28.17,
  height: 29.344,
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_24",
  "data-name": "Group 24"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_23",
  "data-name": "Group 23",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_19",
  "data-name": "Path 19",
  d: "M0,7.082V24.634l8.6,4.71V16.9A15.924,15.924,0,0,1,5.012,9.826Z",
  transform: "translate(0 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_20",
  "data-name": "Path 20",
  d: "M22.388,8.626a14.277,14.277,0,0,1-2.821,7.413v8.595l8.6,4.71V11.792Z",
  transform: "translate(0 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_21",
  "data-name": "Path 21",
  d: "M17.9,7.614c0-.087-.008-.171-.013-.257L11.1,11.069A4.278,4.278,0,0,0,17.9,7.614",
  transform: "translate(0 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_22",
  "data-name": "Path 22",
  d: "M14.2,20.961l-.637.363-.609-.409A22.269,22.269,0,0,1,9.783,18.2V29.344l8.6-4.71v-7.15A18.8,18.8,0,0,1,14.2,20.961",
  transform: "translate(0 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_23",
  "data-name": "Path 23",
  d: "M13.614,19.939s7.635-4.351,7.635-12.325a7.636,7.636,0,0,0-15.272,0c0,7.19,7.637,12.325,7.637,12.325M8.149,7.614a5.464,5.464,0,1,1,5.465,5.449A5.457,5.457,0,0,1,8.149,7.614",
  transform: "translate(0 0)",
  fill: "#fff"
})));

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Inteligentny_obiekt_wektorowy",
    "data-name": "Inteligentny obiekt wektorowy",
    width: 28.17,
    height: 29.344,
    viewBox: "0 0 28.17 29.344",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.d44a221b.svg";
export { ForwardRef as ReactComponent };